import { createNanoEvents } from "@-/com.npmjs.nanoevents";

const learnCardsEmitter = createNanoEvents<{ showCards: () => void }>();

/** Subscribed by Learn while its map is showing: a press of the focused Learn tab leaves it. */
export function subscribeLearnCards(subscriber: () => void) {
  return learnCardsEmitter.on("showCards", subscriber);
}

/**
 * Consume a focused Learn press only while Learn's map is showing: the tab is how the learner gets
 * to the cards, even when Learn opened on its map. Elsewhere in Learn the press dismisses as usual.
 */
export function requestLearnCards(): boolean {
  if ((learnCardsEmitter.events.showCards?.length ?? 0) === 0) {
    return false;
  }
  learnCardsEmitter.emit("showCards");
  return true;
}
